export enum DisplayAdType {
  Normal = 'normal',
  /**
   * 뷰어엔드 확장형 배너
   */
  Extended = 'extended',
}
